import { Outlet } from "@tanstack/react-router"
import { ReactNode, Suspense } from "react"

import { ViewTransition } from "@/components/shared"
import PopupPhoneCheck from "@/components/shared/global/popup-phone-check"
import { LoadingPage } from "@/components/shared/ui/loading-page"
import { Toaster } from "@/components/ui/sonner"
import { useLayoutStore } from "@/modules/helpers/hooks/shared"
import useSyncUser from "@/modules/helpers/hooks/shared/use-sync-user"
import useListenerNavigation from "@/modules/helpers/hooks/use-listenner-navigation"

type ScreenLayoutProps = {
  transition?: "fade" | "push" | "none"
  children?: ReactNode
}

export const ScreenLayout = ({ transition = "push", children }: ScreenLayoutProps) => {
  const { insetBottom, insetTop } = useLayoutStore()
  useListenerNavigation()
  useSyncUser()
  return (
    <ViewTransition transition={transition}>
      <div
        className="flex flex-col h-screen max-h-[100dvh] bg-white"
        style={{
          paddingTop: `${insetTop}px`,
          paddingBottom: `${insetBottom}px`
        }}
      >
        <PopupPhoneCheck />
        <div id="screen-scroll-container" className="flex-1 overflow-scroll bg-white">
          <Suspense fallback={<LoadingPage />}>{children ? children : <Outlet />}</Suspense>
        </div>
        <Toaster position="top-center" mobileOffset={{ top: insetTop + 50 }} />
      </div>
    </ViewTransition>
  )
}

export default ScreenLayout
